import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from '../../../layout/service/user.service';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TabsModule } from 'primeng/tabs';


@Component({
    standalone: true,
    selector: 'app-sheet',
    imports: [CommonModule, ButtonModule, FormsModule, TabsModule],
    template: `
    <div class="min-h-screen flex py-10 bg-gradient-to-br from-blue-50 via-white to-blue-100">
        <div class="w-full px-4 mx-auto flex flex-col md:flex-row gap-8">
            <div class="flex-1">
                <!-- Search bar -->
                <div class="flex flex-col sm:flex-row items-center justify-between mb-8 gap-4">
                    <h2 class="text-3xl font-extrabold text-blue-900 tracking-tight drop-shadow">Daftar Kasus</h2>
                    <div class="relative w-full sm:w-80">
                        <span class="absolute inset-y-0 left-0 flex items-center pl-3">
                            <i class="pi pi-search text-blue-400"></i>
                        </span>
                        <input
                            type="text"
                            [(ngModel)]="searchText"
                            (ngModelChange)="applySearch()"
                            placeholder="Cari kasus..."
                            class="w-full pl-10 pr-4 py-2 border border-blue-200 rounded-xl shadow focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white transition"
                        />
                    </div>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    <div *ngFor="let item of filteredCases; let idx = index"
                        class="relative rounded-3xl shadow-lg border border-blue-100 bg-white p-7 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 hover:border-blue-300 flex flex-col min-h-[240px] group">
                        <!-- Status/Badge -->
                        <div class="absolute top-5 right-5 z-10">
                            <span *ngIf="item.is_active == 1" class="inline-flex items-center gap-1 bg-green-50 text-green-700 text-xs px-3 py-1 rounded-full font-semibold shadow-sm border border-green-200">
                                <i class="pi pi-check-circle text-green-400"></i> Aktif
                            </span>
                            <span *ngIf="item.is_active != 1" class="inline-flex items-center gap-1 bg-red-50 text-red-700 text-xs px-3 py-1 rounded-full font-semibold shadow-sm border border-red-200">
                                <i class="pi pi-times-circle text-red-400"></i> Nonaktif
                            </span>
                        </div>
                        <!-- Card content -->
                        <div class="mb-4">
                            <h3 class="text-xl font-bold text-blue-900 mb-2 truncate group-hover:text-blue-600 transition" [title]="item.name">
                                <i class="pi pi-briefcase mr-2 text-blue-400"></i>{{ item.name }}
                            </h3>
                            <p class="text-gray-600 mb-3 min-h-[48px]">{{ item.description }}</p>
                        </div>
                        <div class="flex flex-wrap gap-2 mb-4">
                            <span class="inline-flex items-center gap-1 bg-blue-50 text-blue-700 text-xs px-3 py-1 rounded font-medium shadow-sm border border-blue-100">
                                <i class="pi pi-clock"></i> {{ item.timer }} min
                            </span>
                            <span class="inline-flex items-center gap-1 bg-yellow-50 text-yellow-700 text-xs px-3 py-1 rounded font-medium shadow-sm border border-yellow-100">
                                <i class="pi pi-calendar"></i> {{ item.created_at | date:'dd MMM yyyy' }}
                            </span>
                        </div>
                        <div class="flex justify-end mt-auto">
                            <button pButton type="button" label="Kerjakan" icon="pi pi-play"
                                class="p-button-primary px-7 py-2 font-semibold shadow-lg rounded-xl bg-gradient-to-r from-blue-500 to-blue-700 border-0 hover:from-blue-600 hover:to-blue-800 hover:scale-105 transition-all duration-200"
                                (click)="goToAnswer(item)"></button>
                        </div>
                    </div>
                </div>
                <div *ngIf="filteredCases.length === 0" class="text-center text-gray-400 py-16">
                    <i class="pi pi-search text-5xl mb-3 animate-bounce"></i>
                    <div class="text-lg font-medium">Tidak ada kasus ditemukan.</div>
                </div>
            </div>
        </div>
    </div>
    `,
    styles: [`
        .p-button-primary {
            background: linear-gradient(90deg, #3b82f6 0%, #2563eb 100%) !important;
            color: #fff !important;
            border: none !important;
            border-radius: 0.75rem !important;
            box-shadow: 0 4px 16px 0 rgba(59,130,246,0.10) !important;
        }
        .p-button-primary:hover {
            background: linear-gradient(90deg, #2563eb 0%, #1e40af 100%) !important;
            transform: scale(1.05);
        }
        .p-button:focus {
            outline: 2px solid #2563eb !important;
            outline-offset: 2px !important;
        }
        .group:hover .group-hover\\:text-blue-600 {
            color: #2563eb !important;
        }
        @media (max-width: 1024px) {
            .grid-cols-3 {
                grid-template-columns: repeat(2, minmax(0, 1fr));
            }
        }
        @media (max-width: 768px) {
            .grid-cols-3, .grid-cols-2 {
                grid-template-columns: repeat(1, minmax(0, 1fr));
            }
        }
    `]
})
export class Sheet implements OnInit {
    cases: any[] = [];
    filteredCases: any[] = [];
    user: any = null;
    userSections: string[] = [];
    searchText: string = '';

    constructor(
        private userService: UserService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.initApi();
        const userStr = localStorage.getItem('user');
        if (userStr) {
            this.user = JSON.parse(userStr);
            try {
                this.userSections = Array.isArray(this.user.LIST_SECTION)
                    ? this.user.LIST_SECTION
                    : JSON.parse(this.user.LIST_SECTION || '[]');
            } catch {
                this.userSections = [];
            }
        }
    }

    initApi(): void {
        this.userService.getSheetCases({
            is_actived: 1
        }).then((res) => {
            this.cases = res.data || [];
            this.applySearch();
        }).catch(() => {
            this.cases = [];
            this.applySearch();
        });
    }

    applySearch(): void {
        const keyword = (this.searchText || '').toLowerCase();
        this.filteredCases = this.cases.filter(item =>
            !keyword ||
            (item.name && item.name.toLowerCase().includes(keyword)) ||
            (item.description && item.description.toLowerCase().includes(keyword))
        );
    }

    goToAnswer(item: any): void {
        this.router.navigate(['/osce/sheet/answer', item.id]);
    }
}
